import { render } from "./customersComponent.vue?vue&type=template&id=6313c710"
import script from "./customersComponent.vue?vue&type=script&lang=js"
export * from "./customersComponent.vue?vue&type=script&lang=js"

import "./customersComponent.vue?vue&type=style&index=0&id=6313c710&lang=scss"

import exportComponent from "/home/lexmodo/projects/wishlist_remote/wishlist_admin/wishlist-frontend-to-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__